// src/pages/Solicitacoes/components/ActionsMenu.jsx
import React from 'react';
import {IconButton, Menu, MenuItem} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export default function ActionsMenu({
    nota,
    anchorEl,
    menuOpenId,
    handleMenuClick,
    handleMenuClose,
    handleMenuAction,
    podeMostrarMenu,
}) {
    if (!podeMostrarMenu(nota.status)) return null;

    return (
        <>
            <IconButton size="small" onClick={(e) => handleMenuClick(e, nota.id)}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={menuOpenId === nota.id}
                onClose={handleMenuClose}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
            >
                {nota.status === 'Aprovado' && (
                    <>
                        <MenuItem onClick={() => handleMenuAction(nota, 'anexarArquivos')}>
                            Fotos e Orçamento
                        </MenuItem>
                    </>
                )}

                {nota.status === 'Pendente' && (
                    <MenuItem onClick={() => handleMenuAction(nota, 'anexarFotos')}>
                        Anexar fotos
                    </MenuItem>
                )}

                {nota.status === 'Encerrado' && (
                    <>
                        <MenuItem onClick={() => handleMenuAction(nota, 'anexarNfs')}>
                            Incluir notas fiscais
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuAction(nota, 'anexarImagens')}>
                            Incluir imagens
                        </MenuItem>
                    </>
                )}
                {/* Só para itens pendentes */}
                {nota.status === 'Pendente' && (
                    <>
                        <MenuItem onClick={() => handleMenuAction(nota, 'alterar')}>
                            Alterar insumo
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuAction(nota, 'excluir')}>
                            Excluir insumo
                        </MenuItem>
                    </>
                )}
            </Menu>
        </>
    );
}
